  <div class="container-fluid">
  <div class="row">
    <div class="col-xl-7" [ngStyle]="{'background-image': 'url(assets/images/login/1.jpg)',
                                     'background-size': '700px',
                                     
                                     'background-position': 'center center',
                                     'display': 'block'}">
      <img class="bg-img-cover bg-center d-none" src="https://thereceptionist.com/your-complete-guide-visitor-management/" alt="looginpage">
    </div>
    <div class="col-xl-5 p-0">
      <div class="login-card">
        <div>
          <div>
            <a class="logo text-left" href="#"style="justify-content: center;"> 
              <img class="img-fluid for-light" src="assets/images/logo/logo-res.png" style="height:70px; " alt="looginpage" >
              
              <img class="img-fluid for-dark" src="assets/images/logo/logo_dark.png" alt="looginpage">
              <h2 style="text-align:center">Visitor Management System</h2>
            </a>
          </div>
          <div class="login-main">
            <form class="theme-form" [formGroup]="form">
              <h4>Enter Email</h4>
              <div class="form-group">
                <div class="col-md-12">
                  <input class="form-control" id="inputEmail3" type="email" placeholder="Email" formControlName="email"
                    [ngClass]="{ 'is-invalid': (isFormSubmitted && form.controls.email.errors) || (!form.controls.email.pristine && form.controls.email.invalid) }"
                    
                    >
                  <div class="invalid-feedback"
                    *ngIf="(isFormSubmitted && form.controls.email.errors) || (!form.controls.email.pristine && form.controls.email.invalid)">
                    <div *ngIf="form.controls.email.errors.required">
                      <h5 style="color:red">Email is required</h5>
                    </div>
                    <div *ngIf="form.controls.email.errors.pattern">
                      <h5 style="color:red">Enter valid emai</h5>
                    </div>
      
                  </div>
                  <div>
                    <button class="btn btn-primary btn-block m-t-10" type="submit" (click)="forgetPassword()">Send</button>
                  </div>
                </div>
                             </div>
           
              <p class="mt-4 mb-0">Already have an password?<a class="ml-2" routerLink="/login">Sign in</a></p>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>